import { PaymentActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { PaymentFormData } from 'src/screens/General/screens/Payments/components/PaymentForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetPaymentsAction {
    type: typeof PaymentActions.FETCH_PAYMENTS;
    payload: QueryParams;
}

export function getPayments(params: QueryParams): GetPaymentsAction {
    return {
        type: PaymentActions.FETCH_PAYMENTS,
        payload: params,
    };
}

export interface GetPaymentAction {
    type: typeof PaymentActions.FETCH_PAYMENT;
    payload: {
        id: string | number;
    };
}

export function getPayment(id: string | number): GetPaymentAction {
    return {
        type: PaymentActions.FETCH_PAYMENT,
        payload: { id },
    };
}

export interface DeletePaymentAction {
    type: typeof PaymentActions.DELETE_PAYMENT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deletePayment(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeletePaymentAction {
    return {
        type: PaymentActions.DELETE_PAYMENT,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistPaymentAction {
    type: typeof PaymentActions.PERSIST_PAYMENT;
    payload: {
        data: PaymentFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistPayment(data: PaymentFormData, callbacks: SagaPromise<any>): PersistPaymentAction {
    return {
        type: PaymentActions.PERSIST_PAYMENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistPayment = (data: PaymentFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistPayment(data, { resolve, reject }));
    });
};

export type Actions = GetPaymentsAction | GetPaymentAction | DeletePaymentAction | PersistPaymentAction;
